import cn from 'classnames';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  MarketplaceCategoryBlock,
  MarketplaceCategoryBlockProps,
} from 'src/components/MarketplaceCategoryBlock';
import { AvailableFilters } from 'src/types/marketplace';
import { Button } from 'src/uikit/Button';
import { CrossIcon } from 'src/uikit/icons/CrossIcon';
import { getFilterKeyMobile } from 'src/utils/marketplace/filter';

import { FilterBlock } from '../FilterBlock';
import { MobileHead } from '../MobileHead';
import s from './MobileFilters.module.scss';

const MocksRu = {
  filter: 'Фильтр',
  close: 'Закрыть',
  submit: 'Готово',
};

type Props = {
  availableFilters: AvailableFilters;
  setVisible: (newVisible: boolean) => void;
};

function CloseFilterButton({ onClose }: { onClose: () => void }) {
  return (
    <Button
      onClick={onClose}
      variant={Button.variants.Tertiary}
      className={s.closeFilters}
      analyticsOptions={{
        action: 'click',
        clickZone: 'body',
        clickElement: 'button',
        clickContent: MocksRu.close,
        uniqueId: 'marketplace-close-filter-mobile-button',
        transitionType: 'inside-link',
      }}
    >
      {MocksRu.close}
      <CrossIcon />
    </Button>
  );
}

export function MobileFilters({
  availableFilters,
  setVisible,
  ...categoryProps
}: MarketplaceCategoryBlockProps & Props) {
  const { setValue, getValues } = useFormContext();

  const closeFiltersMobile = () => {
    setVisible(false);
  };

  const onSubmit = () => {
    availableFilters.forEach(({ filterKey }) => {
      setValue(filterKey, getValues(getFilterKeyMobile(filterKey)));
    });

    setVisible(false);
  };

  useEffect(() => {
    availableFilters.forEach(({ filterKey }) => {
      setValue(getFilterKeyMobile(filterKey), getValues(filterKey));
    });
  }, [availableFilters, setValue, getValues]);

  return availableFilters.length ? (
    <div className={s.root}>
      <div className={s.filterMobile}>
        <div className={cn(s.heading, s.wrapper)}>
          <p>{MocksRu.filter}</p>
          <CloseFilterButton onClose={closeFiltersMobile} />
        </div>

        <div className={s.filterBody}>
          <div className={s.scrollbar}>
            <div className={cn(s.list, s.wrapper)}>
              <MarketplaceCategoryBlock {...categoryProps} />

              {availableFilters.map((filter) => {
                const mobileFilterKey = getFilterKeyMobile(filter.filterKey);

                return (
                  <div key={filter.filterKey}>
                    <MobileHead
                      filterKey={mobileFilterKey}
                      titleKey={filter.titleKey}
                    />

                    <FilterBlock
                      filterKey={mobileFilterKey}
                      titleKey={filter.titleKey}
                      options={filter.options}
                      search={filter.search}
                      collapsable={false}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <Button
          className={s.button}
          onClick={onSubmit}
          analyticsOptions={{
            action: 'click',
            clickZone: 'body',
            clickElement: 'button',
            clickContent: MocksRu.submit,
            uniqueId: 'marketplace-category-filter-button',
            transitionType: 'inside-link',
          }}
        >
          {MocksRu.submit}
        </Button>
      </div>
    </div>
  ) : null;
}
